import { createContext } from 'react';

export const ValidationContext = createContext({
  validations: [],
  controls: [],
  updateValidations: () => {},
  updateControls: () => {},
});
